import React, { Component } from "react";
//import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";

import Typography from "@material-ui/core/Typography";
import Numberformat from "../../atoms/Numberformat";

import Table from "@material-ui/core/Table";
import { TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { Paper, Button } from "@material-ui/core";

import Dialog from "./Dialog";

import PaymentInfo from "../../molecules/Paymentinfo";

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto"
  },
  subheading: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  },
  tablecell: {
    [theme.breakpoints.down("md")]: {
      padding: "4px"
    }
  },
  tablerow: {
    cursor: "pointer"
  }
});

class OrdersUser extends Component {
  constructor(props) {
    super();
    this.showPaymentDetails = this.showPaymentDetails.bind(this);
    this.state = {
      open: false,
      orderIndex: 0
    };
  }
  showPaymentDetails(row) {
    this.setState({ open: true, orderIndex: row });
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, Orders } = this.props;
    if (Orders && Orders.length > 0) {
      return (
        <React.Fragment>
          <Paper className={classes.root} square elevation={0}>
            <Typography variant={"h5"} className={classes.subheading}>
              Orders
            </Typography>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tablecell}>Date</TableCell>
                  <TableCell className={classes.tablecell}>
                    Reference
                  </TableCell>{" "}
                  <TableCell className={classes.tablecell} numeric>
                    Token
                  </TableCell>
                  <TableCell className={classes.tablecell} numeric>
                    Total
                  </TableCell>
                  <TableCell className={classes.tablecell}>State</TableCell>
                  <TableCell className={classes.tablecell}>&nbsp;</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Orders.map(
                  (
                    { OrderDate, OrderNumber, display, currency, Status },
                    index
                  ) => {
                    return (
                      <TableRow
                        key={OrderNumber}
                        onClick={
                          Status === "created" || Status === "failure/error"
                            ? event => this.showPaymentDetails(index)
                            : null
                        }
                        className={
                          Status === "created" || Status === "failure/error"
                            ? classes.tablerow
                            : null
                        }
                      >
                        <TableCell className={classes.tablecell}>
                          {new Date(OrderDate).toLocaleDateString()}
                        </TableCell>
                        <TableCell className={classes.tablecell}>
                          {OrderNumber}
                        </TableCell>
                        <TableCell className={classes.tablecell} numeric>
                          <Numberformat value={display.token} digits={6} />
                        </TableCell>
                        <TableCell className={classes.tablecell} numeric>
                          <Numberformat
                            value={display.sum}
                            digits={currency === "EUR" ? 2 : 6}
                          />
                          &nbsp;{currency}
                        </TableCell>

                        <TableCell className={classes.tablecell}>
                          {Status}
                        </TableCell>
                        <TableCell className={classes.tablecell}>
                          {(Status === "created" ||
                            Status === "failure/error") &&
                            process.env.REACT_APP_STATUS !== "PAUSE" && (
                              <Button
                                onClick={event =>
                                  this.showPaymentDetails(index)
                                }
                              >
                                View
                              </Button>
                            )}
                        </TableCell>
                      </TableRow>
                    );
                  }
                )}
              </TableBody>
            </Table>
          </Paper>
          <Dialog open={this.state.open} onClose={this.handleClose}>
            <PaymentInfo
              order={Orders[this.state.orderIndex]}
              user={this.props.User}
            />
          </Dialog>
        </React.Fragment>
      );
    } else return null;
  }
}

export default withStyles(styles)(OrdersUser);
